import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const StudyTipsPage = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          학습 팁
        </Typography>
        <Typography variant="body1" color="text.secondary">
          효과적인 학습 방법과 팁을 공유해보세요.
        </Typography>
      </Box>
    </Container>
  );
};

export default StudyTipsPage; 